/**
 * Entry point.
 *
 * `@angular/localize/init` is not imported here — it is the sole entry in
 * `polyfills` in angular.json, which is where the CLI needs it. Imported from
 * this file it would be bundled into `main.js` and evaluated after the module
 * graph is already loading, and any module-level `$localize` in a component
 * file would throw before it ran. `polyfills` guarantees it is first.
 *
 * That list is also the reason there is no zone.js: this app is zoneless and
 * `provideZonelessChangeDetection()` in app.config.ts depends on zone.js being
 * absent. If anything ever adds `"zone.js"` to `polyfills`, change detection
 * silently switches back.
 */
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((cause: unknown) => {
  // Nothing above this point can render an error, so the console is the only
  // channel left. A silent white page is the worst possible failure for a demo.
  console.error('[pre2post] bootstrap failed', cause);
});
